export function isOnFreeTrialPage() {
    return window.location.pathname.includes('freetrial');
}
